import React from 'react';
import { APITypes } from '../../../../primary-record-types';
import { getIntl } from '../../../../utils/intl';
import NoteDetailsHeader from './NoteDetailsHeader';
import CommentsList from './NotesCommentsList';
import { NoteEditTab } from '../../../../utils/appNavigationNames';
import { Action } from '../../../v2BaseComponents/ActionButtonLayout/types';
import { ActionButtonLayout } from '../../../v2BaseComponents/ActionButtonLayout';
import { mainContentPadding } from '../../../v2BaseComponents/MainContentContainer';
import Stack from '../../../v2BaseComponents/Stack';
import DetailsTab from './DetailsTab';
import DetailsLayout from '../../../v2BaseComponents/DetailsLayout';

const intl = getIntl('note-details', {
    headerSubtitle: 'Last modified {date} by {user}',
    primaryRecord: 'Primary Record',
    details: 'Details',
    attachments: 'Attachments ({count})',
    comments: 'Comments ({count})',
    edit: 'Edit',
});

export type NoteDetailsOwnProps = {
    note: APITypes.notesService.NoteDetails;
    onEdit: (defaultTab?: NoteEditTab) => void;
    canEdit: boolean;
    editActions: Action[];
    disableComments?: boolean;
    /** Rendered above the note header, for state the reader should see before the content. */
    banner?: React.ReactNode;
    /** Rendered beside the title: the note's link to a counterpart note, when it has one. */
    linkPill?: React.ReactNode;
};

export type NoteDetailsProps = NoteDetailsOwnProps;

const NoteDetails: React.FC<NoteDetailsProps> = (props) => {
    return (
        <ActionButtonLayout
            scrollable
            actions={[
                {
                    title: intl('edit'),
                    icon: 'Edit2',
                    onPress: () => props.onEdit('note'),
                    show: props.canEdit,
                    testID: 'edit-note-button',
                },
                ...props.editActions,
            ]}
        >
            <DetailsLayout>
                <Stack
                    vertical
                    fullWidth
                    space={4}
                    style={{
                        padding: mainContentPadding,
                    }}
                >
                    {props.banner || null}
                    <NoteDetailsHeader note={props.note} trailing={props.linkPill} />
                    <DetailsTab note={props.note} />
                    {props.disableComments ? null : <CommentsList note={props.note} />}
                </Stack>
            </DetailsLayout>
        </ActionButtonLayout>
    );
};

export default React.memo(NoteDetails);
